import { IPage } from '@aon/aon-tws-common-ui';
import axios from 'axios';
import Constants from '../constants';
import { ISurveyListItem, IValidationModel } from '../models';

export async function getSurveys(): Promise<IPage<ISurveyListItem[]>> {
	const res = await axios.get(getSurveysQuery(), { headers: { Pragma: 'no-cache' } });
	if (res.status === 200) {
		return {
			pageRange: JSON.parse(res.headers.range),
			items: res.data,
		};
	}
	throw Error('An error occurred trying to fetch questions');
}

export async function updateSurveyName(listItem: ISurveyListItem): Promise<IValidationModel<ISurveyListItem>> {
	const res = await axios.put(Constants.API_SURVEY_LIST_URL, listItem);
	return res.data;
}

export function getSurveysQuery() {
	let params = Constants.API_SURVEY_LIST_URL + '?offset={offset}&limit={limit}';
	params = params.replace('{offset}', '0');
	params = params.replace('{limit}', '100000');
	return params;
}
